export default {
  'lock.title': 'Oturumunuz sonlandı',
  'lock.username': 'Kullanıcı Adı',
  'lock.password': 'Şifre',
  'lock.question': 'John Doe değil misiniz?',
  'lock.unlock': 'Oturum Aç',
};
